import { useState } from 'react';

import { PageWrapper } from 'pages/Workshop/PageWrapper';

import { PageSearchWrapper } from '../components/PageSearchWrapper';
import { useFetchShowings } from './hooks/useFetchShowings';

import styles from './styles.module.scss';
import { RevampedHeader } from '../components';
import classNames from 'classnames';
import { ShowingActionButtons } from './components/ShowingActionButtons';
import {
  resetShowingAggregateByUserIdSearchEffect,
  searchShowingAggregateByUserIdEffect,
  setShowingsTabEffect,
} from 'store/effects/showingAggregate';
import { useDispatch, useSelector } from 'react-redux';
import { getUserId } from 'store/selectors/user';
import { ShowingsContent } from './components/ShowingsContent';
import { getActiveShowingTabSelector } from 'store/selectors/showingAggregate';

export const Showings = () => {
  const [isSearchActive, setSearchActive] = useState(false);
  const userId = useSelector(getUserId);
  const dispatch = useDispatch();
  const { activeShowingTab } = useSelector(getActiveShowingTabSelector);

  const { aggregateFilters, isFiltersApplied, ...fetchProps } = useFetchShowings();

  const resetShowingTab = () => {
    activeShowingTab && dispatch(setShowingsTabEffect(null));
  };

  return (
    <>
      <PageWrapper
        isContainer={false}
        isHideFooter
        pageWrapperContainerClassName={styles.mainPageContent}
      >
        <RevampedHeader
          className={classNames(styles.workshopPageHeader, {
            [styles.activeSearchWorkshopPageHeader]: isSearchActive,
          })}
          title={'Showings'}
          titleClassName={styles.headerTitle}
          actionButtons={
            <ShowingActionButtons
              onSearchClick={() => {
                resetShowingTab();
                setSearchActive(true);
              }}
            />
          }
        />

        <PageSearchWrapper
          isSearchActive={isSearchActive}
          resetAction={() => resetShowingAggregateByUserIdSearchEffect(userId, aggregateFilters)}
          sendAction={({ search }) =>
            searchShowingAggregateByUserIdEffect({ search, userId, filters: aggregateFilters })
          }
          onCloseSearch={() => setSearchActive(false)}
          otherSearchParams={{ aggregateFilters }}
        />

        <ShowingsContent
          {...fetchProps}
          showListView={isSearchActive || isFiltersApplied}
          isSearchActive={isSearchActive}
        />
      </PageWrapper>
    </>
  );
};
